module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1jnz06SVsgmSUU2uaGwCCo-aee5e993fe59e6ffd41e0950099170b6.jpg";